import request from '@/js/request';

/**
 * 获取广告列表
 * @param {Object} params - 请求参数
 * @param {string} params.gameCode - 游戏代码
 * @param {string} params.adPlace - 广告位置
 * @param {number} params.resource - 资源类型 (1: app, 2: 其他)
 * @returns {Promise} - 返回广告列表数据
 */
export function getAdsList(params) {
  return request.methods('/web/plat-game-api/getAd', 'POST', params);
}

